import * as $ from 'jquery';


export default class Blog {

    constructor () {
        // nav fixed on scroll
        let $nav_wrapper = $('.teleshopping-and-you').find('.nav-wrapper'),
            $nav = $nav_wrapper.find('nav'),
            $nav_offset_top = $nav.offset().top;

        $(window).scroll(function () {
            if ($(window).scrollTop() >= $nav_offset_top) {
                if (!$nav.hasClass('fixed')) {
                    $nav_wrapper.height($nav.height());
                    $nav.addClass('fixed');
                }
            } else {
                if ($nav.hasClass('fixed')) {
                    $nav_wrapper.height('auto');
                    $nav.removeClass('fixed');
                }
            }
        });

        let $arrArticle = $('.teleshopping-and-you .articles');

        // extension des liens
        $arrArticle.find('.article').click(function () {
            window.location.href = $(this).find('h3 > a').attr('href');
        });

        $arrArticle.find('.main-product').click(function () {
            window.location.href = $(this).find('a.btn').attr('href');
        });

        // cursor pointer sur les blocks
        $arrArticle.find('.article').on('mouseover', function () {
            $(this).css('cursor', 'pointer');

        });

        $('.subjects .produits-associes').find('.main-product').on('mouseover', function () {
            $(this).css('cursor', 'pointer');
        });

        // smooth scroll
        $('.nav-wrapper').find('a').on('click', function () {
            let page = $(this).attr('href');
            let speed = 750;
            $('html, body').animate({scrollTop: $(page).offset().top}, speed);
            return false;
        });
         $('.articles a').attr('target', '_blank');


    }
}